import { SparklesIcon } from "@heroicons/react/24/outline";
import classNames from "classnames";

/**
 * Round button stacked above Messages. Uses the same right-edge offset.
 *
 * @param {{ onClick: Function, open?: boolean }} props
 */
export default function AssistantLauncher({ onClick, open = false }) {
  return (
    <button
      type="button"
      onClick={onClick}
      className={classNames(
        "fixed bottom-20 right-5 z-[60] shadow-lg rounded-full",
        "bg-gray-900 hover:bg-gray-800 text-white",
        "h-12 w-12 flex items-center justify-center"
      )}
      style={{
        right: "calc(1.25rem + var(--right-sidebar-offset, 0px))",
      }}
      title={open ? "Close assistant" : "Assistant"}
      aria-pressed={open}
    >
      <SparklesIcon className="h-6 w-6" />
    </button>
  );
}
